import React, { Component } from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar';
import { Box, Flex } from '@chakra-ui/react';
import FooterMP from "../FooterMP";

export default class Layout extends Component {

    render() {

        const { page, children, currentCateory, entidadeHref, entidade, pagina } = this.props;
        return (
            <Flex flexDir={"column"} >
                <Flex
                    minH={"100vh"}
                    h={"100%"}
                    position={"absolute"}
                    backgroundColor={"#DDEBEA"}
                    overflow={"hidden"}
                    w="100%"
                    flexDir="row"
                    maxW="100%"
                >

                    <Sidebar
                        display={currentCateory === "Página não encontrada" && "none"}
                        page={page} entidade={entidade} categoria={currentCateory} />

                    <Flex
                        w="100%"
                        p={0}
                        flexDir="column"
                        overflow={"auto"}
                    >
                        <Navbar
                            page={page}
                            display={currentCateory === "Página não encontrada" && "none"}
                            categoria={currentCateory}
                            entidadeHref={entidadeHref}
                            entidade={entidade}
                            pagina={pagina}

                        />
                        <Box flex="1" display="flex" flexDir="column">
                            {children}
                        </Box>

                        <FooterMP display={currentCateory === "Página não encontrada" && "none"} />
                    </Flex>

                </Flex>

            </Flex>
        )
    }
}